import { apiClass } from '../../class/api.class'
import { ENDPOINTS } from '../../const/endpoints.const'

const state = {
  loading: false,
  errorData: null,
  statusData: null,
  redirectUrl: null
}
const mutations = {
  SET_REGISTERSIM_LOADING (state, value) {
    state.loading = value
  },
  SET_REGISTERSIM_ERROR_DATA (state, data) {
    state.errorData = data
  },
  SET_REGISTERSIM_STATUS_DATA (state, data) {
    state.statusData = data
  },
  SET_REGISTERSIM_REDIRECT_URL (state, value) {
    state.redirectUrl = value
  }
}
const actions = {
  sendRegisterSimData ({ commit }, data) {
    commit('SET_REGISTERSIM_LOADING', true)
    commit('SET_REGISTERSIM_ERROR_DATA', null)
    return apiClass.post(ENDPOINTS.registerSim.sendRegisterData, data)
      .then(response => {
        commit('SET_REGISTERSIM_REDIRECT_URL', response.body.redirectUrl)
        return Promise.resolve()
      })
      .catch(error => {
        commit('SET_REGISTERSIM_LOADING', false)
        commit('SET_REGISTERSIM_ERROR_DATA', error.body)
        return Promise.reject(error.body)
      })
  },
  getRegisterSimStatus ({ commit }, id) {
    commit('SET_REGISTERSIM_LOADING', true)
    const endpoint = ENDPOINTS.registerSim.getRegisterStatus.replace('{ID}', id)
    return apiClass.get(endpoint)
      .then(response => {
        commit('SET_REGISTERSIM_STATUS_DATA', response.body)
      })
      .catch(error => {
        commit('SET_REGISTERSIM_ERROR_DATA', error.body)
      })
      .finally(() => {
        commit('SET_REGISTERSIM_LOADING', false)
      })
  }
}
const getters = {}

export default {
  state,
  mutations,
  actions,
  getters
}
